import MINIMAL_IMAGE_0 from 'assets/images/photobooks/layout-step/minimal_0.png';
import MINIMAL_IMAGE_1 from 'assets/images/photobooks/layout-step/minimal_1.png';
import MINIMAL_IMAGE_2 from 'assets/images/photobooks/layout-step/minimal_2.png';

import CLASSIC_IMAGE_0 from 'assets/images/photobooks/layout-step/classic_0.png';
import CLASSIC_IMAGE_1 from 'assets/images/photobooks/layout-step/classic_1.png';
import CLASSIC_IMAGE_2 from 'assets/images/photobooks/layout-step/classic_2.png';

import BOLD_IMAGE_0 from 'assets/images/photobooks/layout-step/bold_0.png';
import BOLD_IMAGE_1 from 'assets/images/photobooks/layout-step/bold_1.png';
import BOLD_IMAGE_2 from 'assets/images/photobooks/layout-step/bold_2.png';

export const ALBUM_NAVIGATION_DIRECTIONS = {
  previous: 'PREVIOUS',
  next: 'NEXT',
};

export const ALBUM_NAVIGATION_DIRECTIONS_LIST = Object.values(ALBUM_NAVIGATION_DIRECTIONS);

export const PAGE_SIDES = {
  right: 'RIGHT',
  left: 'LEFT',
};

export const PAGE_SIDES_LIST = Object.values(PAGE_SIDES);

export const OPTIONS_LABELS = {
  'endsheet-type': 'End Sheet',
  'cameo-position': 'Cameo',
  'hinge-type': 'Style',
  'book-size': 'Size',
  'cover-design': 'Color',
  'paper-type': 'Paper Type',
  'cover-type': 'Cover Style',
};

export const DRAFT_TABLE_LABELS = {
  album: ['ITEM', 'IMAGES', 'PAGES', 'PRICE'],
  box: ['ITEM', 'PRICE'],
};

export const ORDER_TABLE_LABELS = {
  album: ['ITEM', 'IMAGES', 'PAGES', 'QTY', 'PRICE'],
  box: ['ITEM', 'PRICE'],
};

export const ALBUM_TYPE_KEYS = {
  classic: 'classic',
  premier: 'premier',
  deluxe: 'deluxe',
};

export const albumLayoutTypes = ['MINIMALIST', 'CLASSIC', 'BOLD'];
export const albumLayoutTypeData = {
  MINIMALIST: {
    images: [MINIMAL_IMAGE_0, MINIMAL_IMAGE_1, MINIMAL_IMAGE_2],
    description: 'Fewer collages, more full-page photos',
  },
  CLASSIC: {
    images: [CLASSIC_IMAGE_0, CLASSIC_IMAGE_1, CLASSIC_IMAGE_2],
    description: 'Mix of collages and full-page photos',
  },
  BOLD: {
    images: [BOLD_IMAGE_0, BOLD_IMAGE_1, BOLD_IMAGE_2],
    description: 'Mostly collages, with a playful feel',
  },
};

// TODO: ask BE if they could sort them instead of having to do it in the FE
export const SORTED_ALBUM_TYPES = ['classic', 'premier', 'deluxe'];

export const FIRST_TIME_EXP_STORAGE_KEY_CUSTOMIZE_STEP_PROGRESS =
  'ZOLA_PHOTOBOOKS_CUSTOMIZE_STEP_FIRST_TIME_EXPERIENCE_PROGRESS';

export const FIRST_TIME_EXP_STORAGE_KEY_CUSTOMIZE_STEP_MAIN =
  'ZOLA_PHOTOBOOKS_CUSTOMIZE_STEP_FIRST_TIME_EXPERIENCE_MAIN';

export const VALIDATION_KEYS = {
  customizationMissing: 'CUSTOMIZATION_MISSING', // An album without any customization
  customizationUuidMissing: 'CUSTOMIZATION_UUID_MISSING', // An album with an invalid customization
  customizationHeightInvalid: 'CUSTOMIZATION_HEIGHT_INVALID', // An album which height is not in the sizes we offer
  customizationWidthInvalid: 'CUSTOMIZATION_WIDTH_INVALID', // An album which width is not in the sizes we offer
  spreadIndexMissing: 'SPREAD_INDEX_MISSING', // An album with a spread that has no proper positioning
  layoutUuidMissing: 'LAYOUT_UUID_MISSING', // An album with a spread not linked to a layout
  slotKeyMissing: 'SLOT_KEY_MISSING', // A slot that doesn't belong to the layout
  slotInvalidWidth: 'SLOT_INVALID_WIDTH', // A slot with a wrong width, 0 or more than the album width
  slotInvalidHeight: 'SLOT_INVALID_HEIGHT', // A slot with a wrong height, 0 or more than the album height
  customizationNotEnoughSpreads: 'CUSTOMIZATION_NOT_ENOUGH_SPREADS', // An album with less than 10 non empty spreads
  customizationTooManySpreads: 'CUSTOMIZATION_TOO_MANY_SPREADS', // An album with more than 40/45 non empty spreads
  lowResPhotos: 'LOW_RES_PHOTOS', // A slot with a low resolution photo
  spreadEmpty: 'SPREAD_EMPTY', // An empty spread (no photo at all)
  slotEmpty: 'SLOT_EMPTY', // An empty slot (no photo on the slot)
  duplicatePhoto: 'DUPLICATE_PHOTOS', // A photo used twice in an album
  skippedPages: 'SKIPPED_PAGES', // A spread that hasn't been reviewed by the user
};

export const ERROR_LEVELS = {
  error: 'ERROR',
  warning: 'WARNING',
};

export const ERROR_TYPE = {
  system: 'SYSTEM',
  user: 'USER',
};

export const STEP_KEYS = {
  layout: 'layout',
  upload: 'upload',
  organize: 'organize',
  highlight: 'highlight',
  customize: 'customize',
  cover: 'cover',
};

export const UUID_LENGTH = 36;

export const COVER_FONT_SIZE_DROPDOWN_CONSTANTS = {
  ALL_SIZES: [22, 24, 26, 28, 30, 32, 34, 36, 40, 44, 48, 52, 56, 60],
  NUM_VISIBLE: 8,
  DEFAULT_SIZE: 36,
};

export const MAX_COVER_LINES = 4;

// Six minutes
export const IMAGE_COPY_TIMEOUT = 360000;

export const THUMBNAIL_WIDTH = 256;

interface AlbumTypeInfoType {
  [key: string]: {
    additionalPageCost: string;
    albumVibe: string;
    coverMaterial: string;
    coverTextFoilColors: string;
    pageCount: string;
    paperDescription: string;
    paperGsm: string;
    paperThickness: string;
    paperTypes: string;
  };
}

export const ALBUM_TYPE_INFO: AlbumTypeInfoType = {
  classic: {
    albumVibe: 'Effortless elegance',
    coverMaterial: 'Linen',
    paperThickness: 'Medium',
    paperGsm: '300gsm',
    paperDescription: 'Like a fancy invitation',
    pageCount: '20 pages',
    additionalPageCost: '$4.50',
    coverTextFoilColors: 'Gold, Rose Gold, or Silver',
    paperTypes: 'Soft Gloss or Satin',
  },
  premier: {
    albumVibe: 'Timeless beauty',
    coverMaterial: 'Linen or Vegan Leather',
    paperThickness: 'Heavy',
    paperGsm: '700gsm',
    paperDescription: 'Like a sturdy notebook cover',
    pageCount: '20 pages',
    additionalPageCost: '$5.00',
    coverTextFoilColors: 'Gold, Rose Gold, or Silver',
    paperTypes: 'Soft Gloss or Satin',
  },
  deluxe: {
    albumVibe: 'All-out luxury',
    coverMaterial: 'Refined Italian Leather',
    paperThickness: 'Heavy',
    paperGsm: '700gsm',
    paperDescription: 'Like a sturdy notebook cover',
    pageCount: '20 pages',
    additionalPageCost: '$5.00',
    coverTextFoilColors: 'Gold, Rose Gold, or Silver',
    paperTypes: 'Soft Gloss or Satin',
  },
};
